import { useMemo } from 'react';

import { Breadcrumbs } from '@dbt-labs/sourdough';

import { useLinkToExplorer } from '@/hooks/links';
import { useUrlProjectParams } from '@/hooks/params';
import {
  useProjectBreadcrumbs,
  useResourceTypeBreadcrumb,
} from '@/hooks/useBreadcrumbs';
import { NavigationResourceType } from '@/panel/ResourcesFilter/selectedResource';
import { truthy } from '@/util/array';

type ResourceBreadcrumbsProps = {
  resourceType: NavigationResourceType | 'package';
  name: string;
  sourceName?: string | null;
};

export const ResourceBreadcrumbs = ({
  resourceType,
  sourceName,
  name,
}: ResourceBreadcrumbsProps) => {
  const projectScope = useUrlProjectParams();
  const getSourceCollectionUrl = useLinkToExplorer('sourceCollectionFilter');

  const resourceTypeBreadcrumb = useResourceTypeBreadcrumb({
    resourceType,
    includeLink: true,
  });

  const additionalItems = useMemo(() => {
    return [
      resourceTypeBreadcrumb,
      sourceName
        ? {
            text: sourceName,
            href: getSourceCollectionUrl({
              ...projectScope,
              sourceName,
            }),
          }
        : undefined,
      { text: name },
    ].filter(truthy);
  }, [resourceTypeBreadcrumb, sourceName, getSourceCollectionUrl, projectScope, name]);

  const breadcrumbs = useProjectBreadcrumbs({
    additionalItems,
  });

  return <Breadcrumbs className="mb-3" breadcrumbs={breadcrumbs} />;
};
